"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Logs messages via a UI butter.
 */
var Logger =
/*#__PURE__*/
function () {
  /**
   * @param {Element} element
   */
  function Logger(element) {
    _classCallCheck(this, Logger);

    /** @type {Element} */
    this.el = element;
    this._id = undefined;
  }
  /**
   * Shows a butter bar.
   * @param {string} msg The message to show.
   * @param {boolean=} autoHide True to hide the message after a duration.
   *     Default is true.
   */


  _createClass(Logger, [{
    key: "log",
    value: function log(msg) {
      var _this = this;

      var autoHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this._id && clearTimeout(this._id);
      this.el.textContent = msg;
      this.el.classList.add('show');

      if (autoHide) {
        this._id = setTimeout(function (_) {
          _this.el.classList.remove('show');
        }, 7000);
      }
    }
    /**
     * @param {string} msg
     */

  }, {
    key: "warn",
    value: function warn(msg) {
      this.log('Warning: ' + msg);
    }
    /**
     * @param {string} msg
     */

  }, {
    key: "error",
    value: function error(msg) {
      this.log(msg); // Rethrow to make sure it's auditable as an error, but in a setTimeout so page
      // recovers gracefully and user can try loading a report again.

      setTimeout(function (_) {
        throw new Error(msg);
      }, 0);
    }
    /**
     * Explicitly hides the butter bar.
     */

  }, {
    key: "hide",
    value: function hide() {
      this._id && clearTimeout(this._id);
      this.el.classList.remove('show');
    }
  }]);

  return Logger;
}(); // if (typeof module !== 'undefined' && module.exports) {
//   module.exports = Logger;
// }


var _default = Logger;
exports["default"] = _default;